"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (ticks) {
    return ticks && ticks.length > 0 ? ticks[ticks.length - 1].quote : undefined;
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/ticks/getLastTickQuote.js
// module id = 117
// module chunks = 0